// import Swiper from "swiper"
import { q, qq } from "../../helper/q"
import { Swiper, Navigation, Pagination } from "swiper/dist/js/swiper.esm.js"
Swiper.use([Navigation, Pagination])

export let productSlider = {}

export const productSliderInit = () => {
  const sliderElement = q(".descriptionSlider")
  const slideElements = qq(".descriptionSliderSlide")
  const sliderArrow = q(".descriptionSliderButtons")
  if (sliderElement) {
    let options = {
      slidesPerView: 1,
      navigation: {
        nextEl: ".descriptionSliderButtonNext",
        prevEl: ".descriptionSliderButtonPrev"
      },
      pagination: {
        el: ".descriptionSliderPagination",
        type: "bullets",
        clickable: "true"
      }
    }

    if (slideElements.length === 1) {
      options = {
        ...options,
        simulateTouch: false,
        pagination: "",
        navigation: ""
      }
      sliderArrow.classList.add("descriptionSliderButtonsHidden")
    }
    productSlider = new Swiper(sliderElement, options)
  }
}
